import {ButtonProps, FormControlLabelProps, LinkProps, ToggleButtonProps, TypographyVariant} from '@mui/material'
import {DataCyProps} from '../dataCyProps'

export interface OcTypographyInfo {
    typoVariant?: TypographyVariant
    typoColor?: 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error'
}

export interface OcButtonProps extends DataCyProps, OcTypographyInfo, ButtonProps {
    tooltip?: string
    fullWidth?: boolean
}

export interface OcToggleButtonProps extends DataCyProps, OcTypographyInfo, ToggleButtonProps {
    tooltip?: string
    fullWidth?: boolean
}

export interface OcLinkProps extends DataCyProps, LinkProps {
    tooltip?: string
    typographyClass?: string
}

export interface OcFormControlProps
    extends DataCyProps,
        OcTypographyInfo,
        Omit<FormControlLabelProps, 'control' | 'color'> {
    controlType: 'checkbox' | 'switch' | 'radio'
    controlColor?: 'primary' | 'secondary' | 'default'
    controlSize?: 'small' | 'medium'
    checkboxIndeterminate?: boolean
    tooltip?: string
    controlStyle?: Record<string, any>
}

export function getTypographyColor(props: OcButtonProps | OcFormControlProps | OcToggleButtonProps) {
    if (props?.disabled) {
        return 'inherit'
    } else if (props.typoColor) {
        return props.typoColor
    }
    return undefined
}
